import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from 'gatsby-link';
import arrow from 'images/arrow-dk.svg';
import arrowRight from 'images/arrow-right.svg';
import { colors, sp, boxShadow } from 'styles/theme';

// prettier-ignore
const StyledButton = styled.button`
  display: inline-block;
  transition: all 0.3s;
  border: 0;
  border-radius: 4px;
  background-color: ${colors.royal};
  padding: 0 30px;
  height: 50px;
  text-align: center;
  color: ${colors.white};
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;

  ${props => props.block && `
    display: block;
  `}

  ${props => props.scroll && `
    background-image: url('${arrow}');
    background-size: 13px 8px;
    background-position: 90% center;
    background-repeat: no-repeat;
    padding: 0 70px 0 30px;
  `}

  ${props => props.right && `
    background-image: url('${arrowRight}');
    background-position: 90% center;
    background-repeat: no-repeat;
    padding: 0 70px 0 30px;
  `}

  ${props => props.blue && `
    background-color: ${colors.blue};
  `}

  ${props => props.grey && `
    background-color: ${colors.grey};
  `}

  ${props => props.yellow && `
    background-color: ${colors.yellow};
    color: ${colors.royal};
  `}

  ${ props => props.white && `
    background-color: ${colors.white};
    color: ${colors.royal};
    box-shadow: ${boxShadow.small};
  `}

  ${props => props.small && `
    padding: 0 20px;
    height: 40px;
  `}

  img {
    &:first-child {
      margin-right: ${sp.xl};
    }

    &:last-child {
      margin-left: ${sp.xl};
    }
  }
`

const LinkButton = StyledButton.withComponent(
  ({ block, blue, white, scroll, small, ...props }) => <Link {...props} />,
);

const AButton = StyledButton.withComponent('a');

const Content = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
// prettier-enable

const propTypes = {
  type: PropTypes.oneOf(['button', 'submit']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  type: 'button',
  disabled: false,
  onClick: () => {},
  to: undefined,
  href: undefined,
};

function Button(props) {
  const { to, onClick, href, type, disabled } = props;
  const internals = <Content>{props.children}</Content>;

  if (to)
    return (
      <LinkButton to={to} onClick={onClick} {...props}>
        {internals}
      </LinkButton>
    );

  if (href)
    return (
      <AButton href={href} onClick={onClick} {...props}>
        {internals}
      </AButton>
    );

  return (
    <StyledButton onClick={onClick} type={type} disabled={disabled} {...props}>
      {internals}
    </StyledButton>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/Button/Button.jsx